import * as React from "react"
import * as ReactDOM from "react-dom/client"
import { App } from "./App"
import reportWebVitals from "./reportWebVitals"
import * as serviceWorker from "./serviceWorker"
import { QueryClient, QueryClientProvider } from "react-query"
import { AuthProvider } from "react-oidc-context"
import { oidcConfig } from "./generic/oidc"
import { AuthBridge } from "./components/AuthBridge"
import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'


const container = document.getElementById("root")
if (!container) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(container)

export const QUERY_CLIENT = new QueryClient();
QUERY_CLIENT.setDefaultOptions({
  queries: {
    refetchOnWindowFocus: false,
    retry: 0,
  },
  mutations: {
    retry: 0,
  },
});


root.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
      <QueryClientProvider client={QUERY_CLIENT}>
        <AuthBridge />
        <App />
      </QueryClientProvider>
    </AuthProvider>
  </React.StrictMode>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister()

reportWebVitals()
